var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.cssClasses,attrs:{"to":_vm.to,"href":_vm.href,"target":_vm.target,"color":_vm.color,"outlined":_vm.outlined,"elevation":_vm.elevation,"rounded":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }